import styled from 'styled-components';
import primitives from '@veneer/primitives';

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StatusText = styled.span`
  margin-left: ${primitives.layout.size2}px;
`;
